import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import Input from '../common/Input';
import Button from '../common/Button';
import { Mail } from 'lucide-react';

const ResetPasswordForm: React.FC = () => {
  const { resetPassword, isLoading, error } = useAuth();
  const { labels } = useLanguage();
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSuccess(false);
    await resetPassword(email);
    setSuccess(true);
  };

  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <div>
        <Input
          id="reset-email"
          name="email"
          type="email"
          autoComplete="email"
          required
          label={labels.email}
          value={email}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
          leftIcon={<Mail size={18} />}
          fullWidth
        />
      </div>
      {error && (
        <div className="bg-error-50 text-error-700 p-3 rounded-md text-sm">{error}</div>
      )}
      {success && (
        <div className="bg-success-50 text-success-700 p-3 rounded-md text-sm">
          {labels.resetPasswordMessage}
        </div>
      )}
      <div>
        <Button type="submit" variant="primary" isLoading={isLoading} isFullWidth>
          {labels.sendResetLink}
        </Button>
      </div>
    </form>
  );
};

export default ResetPasswordForm; 